@for (button of buttons(); track button.action.title) {
  @if (button.visible) {
    @switch (button.action.mode) {
      @case (ActionMode.Navigate) {
        <a
          [routerLink]="button.routerLink"
          [class]="button.action.buttonType | buttontypepipe"
          class="btn-sm btn"
          translate
          [info]="
            button.action.customParameter
              | replaceActionCustomParameterByValue
                : 'idProperty'
                : this.model()?.[button.action.idProperty]
              | jsonParse
          "
        >
          {{ button.action.title }}
        </a>
      }
      @case (ActionMode.Action) {
        <a
          [class]="button.action.buttonType | buttontypepipe"
          class="btn-sm btn"
          (click)="triggerAction(button.action.actionName)"
          translate
        >
          {{ button.action.title }}
        </a>
      }
    }
  }
}
